import { render, staticRenderFns } from "./CartNotEmpty.vue?vue&type=template&id=e28a325e&scoped=true"
import script from "./CartNotEmpty.vue?vue&type=script&lang=js"
export * from "./CartNotEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28a325e",
  null
  
)

export default component.exports